export enum Env {
    DEV = 'dev',
    PROD = 'prod',
    TEST = 'test'
}

type EnvVars = {
    REACT_APP__ENV?: string
    REACT_APP__API_HOST?: string,
    REACT_APP__IMAGES_HOST?: string,
    REACT_APP__OFFER_HOST?: string
}

export interface AppConfig {
    readonly apiUrl: string;
    readonly env: Env;
    readonly offerUrl: string;
    readonly photosUrl: string;
}

const envVars: EnvVars = process.env as EnvVars;

const appConfig: AppConfig = {
    env: envVars.REACT_APP__ENV as Env || Env.DEV,
    apiUrl: `https://${envVars.REACT_APP__API_HOST}/api/agency-offer/v1`,
    offerUrl: `https://${envVars.REACT_APP__OFFER_HOST}/`,
    photosUrl: `https://${envVars.REACT_APP__IMAGES_HOST}/images/`,
};

export default appConfig;

